import {Component} from 'react'
import {toastr} from 'react-redux-toastr'
import {Link} from 'react-router-dom'
import { startOfDay, format, parseISO } from 'date-fns'
import {TabContent, TabPane} from "reactstrap"
import File from 'react-feather/dist/icons/file.js'
import Users from 'react-feather/dist/icons/users.js'
import MessageCircle from 'react-feather/dist/icons/message-circle.js'
import Clock from 'react-feather/dist/icons/clock.js'
import Download from 'react-feather/dist/icons/download.js'
import Linkedin from 'react-feather/dist/icons/linkedin.js'

import conf from "../../../../conf.js"
import {generate} from "../../../../routes"
import api from '../../../../../api.js'
import {downloadFile} from "../../../../services/downloadService.js"
import connectModal from '../../../../../shared/components/Modals/connect.js'
import MustBeAdmin from '../../../../components/Must/MustBeAdmin.jsx'
import Loader from "../../../../../shared/components/Loader/Loader.jsx"

import Notes from '../../../../components/Notes/Notes.jsx'
import CommentsModal from '../../../../components/Modals/CommentsModal/CommentsModal.jsx'
import ModerationLoaded from '../../../../components/Moderations/ModerationsLoaded.jsx'
import ModerationLoading from '../../../../components/Moderations/ModerationsLoading.jsx'
import SubmitButton from '../../../../components/Forms/AdminFreelanceMonitorForm/SubmitButton.jsx'
import AdminFreelanceMonitorForm
  from '../../../../components/Forms/AdminFreelanceMonitorForm/AdminFreelanceMonitorForm.jsx'
import Labels from '../../../../components/Freelance/Component/Labels/Labels.jsx'

import {NavTabs} from "../../../../../shared/components/Tabs/NavTabs.jsx"
import {InterviewNote} from "../../../../../shared/components/InterviewNote/InterviewNote.jsx"
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx"
import DivCenterAlign from "../../../../../shared/components/Styled/DivCenterAlign.jsx"

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService'
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService'

import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

const formatDate = (dateStr) => {
  if (!dateStr) return '-'
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return '-'
  }
}

const universes = ['-', 'Achats & Supply', 'Finance', 'Ressources Humaines', 'Ingénierie']

const TABS = {
  COMMENTARY: 'commentary',
  INTERVIEW_COMMENTARY: 'interview_commentary',
  HISTORY: 'history',
}
export class Monitor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      notes: [],
      currentTab: TABS.INTERVIEW_COMMENTARY,
      historyLoading: false,
      historyData: [],
      dcLoading: false,
    }
    this.hasInterviewInitialData = this.props.freelance && !!this.props.freelance.initial_interview_data
  }

  componentDidUpdate = async (prevProps, prevState, prevContext) => {
    if (prevProps.freelance.id !== this.props.freelance.id) {
      await this.loadComments()
    }
    if (prevProps.user.id !== this.props.user.id) {
      await this.loadHistory(this.props.user)
    }
  }

  componentDidMount = async () => {
    await this.loadComments()
    await this.loadHistory(this.props.user)
  }

  onFormSuccess = async () => {
    await this.loadComments()
    toastr.success('Le commentaire a été correctement ajouté')
  }

  onDelete = async (id) => {
    try {
      const result = await api.freelances.notes.remove({
        freelance: this.props.freelance.id,
        note: id,
      })
      await this.loadComments()
      return result
    } catch (e) {
      console.warn(e)
    }
  }

  addComment = () => {
    this.props.openCommentsModal({
      freelance: this.props.freelance,
      onFormSuccess: this.onFormSuccess,
    })
  }

  onEdit = async (values) => {
    this.props.openCommentsModal({
      freelance: this.props.freelance,
      onFormSuccess: this.onFormSuccess,
      comment: values,
    })
  }

  loadHistory = async (user) => {
    this.setState({ historyLoading: true })
    try {
      const moderations = await api.users.moderation.getAll({ user: user.id })
      this.setState({ historyLoading: false, historyData: moderations.data })
    } catch (e) {
      this.setState({ historyLoading: false })
    }
  }

  loadComments = async () => {
    try {
      const notes = (await api.freelances.notes.getAll({
        freelance: this.props.freelance.id,
      })).data
      this.setState({
        notes,
      })
    } catch (e) {
      console.warn(e)
    }
  }

  editInterviewForm = (values) => {
    const { match, location, link } = this.props
    const rootPath = link.menu ? link.menu : 'search.view'

    const generatedLink = generate({
      name: `${rootPath}.interview`,
      parameters: match.params,
      search: location.search
    })

    this.props.history.push(generatedLink)
  }

  setCurrentTab = (tab) => {
    this.setState({currentTab: tab})
  }

  downloadCvNormalized = (anonymized = false, whiteMarking = false) => {
    return api.freelances.cv.getNormalized({
      freelance: this.props.freelance.id,
      anonymized: anonymized || false,
      whiteMarking: whiteMarking || false
    })
      .then((blob) => {
        const firstname = this.props.user?.firstname ?? ''
        const freelanceId = this.props.freelance?.id ?? 0
        const dateFormatted = format(new Date(), 'yyyyMMdd')
        const name = `${dateFormatted}-CV_Twineeds-${firstname}-${freelanceId}`
        return downloadFile(blob, name, 'pdf')
      })
      .catch((err) => console.warn(err))
  }

  onCvNormalizedDownloaded = async (anonymized = false, whiteMarking = false) => {
    this.setState({dcLoading: true})
    this.downloadCvNormalized(anonymized, whiteMarking)
      .finally(() => {
        this.setState({dcLoading: false})
      })
  }

  render() {
    const {user, freelance, link, match} = this.props
    const rootPath = link?.menu ?? 'search.view'
    const cvUrl = generate({ name: `${rootPath}.cv`, parameters: match.params })
    const linkedinUrl = user?.linkedin_url || generate({ name: `${rootPath}.pres`, parameters: match.params, hash: '#pres-linkedin' })
    const lastCvEntry = (this.state.historyData ?? []).reduceRight((found, entry) => found ?? (entry.description?.includes('CV uploadé') ? entry : null), null)
    const {notes = [], historyData = []} = this.state

    return (
      <div className="d-flex" style={{gap: 10}}>
        <Loader visible={!!this.state.dcLoading}>Téléchargement du DC ...</Loader>
        <div className="flex-fill">
          <FreelancePage className="mb-3">
            <h2 className="text-center mb-2">Suivi {user?.fullname ?? ''}</h2>

            <Labels freelance={freelance} user={user} withUniverse={true} className="mb-5"/>
            <AdminFreelanceMonitorForm
              keepDirtyOnReinitialize={false}
              enableReinitialize={true}
              onSubmit={this.props.submitUserFreelance}
              isReviewed={freelance?.is_reviewed}
              currentRegistrationStep={freelance?.current_registration_step ?? null}
              hasStoppedSms={user?.alert_offers[0].stop_sms}
              hasSkillsFileUploaded={!!freelance?.skills_file}
              history={this.state.historyData}
              initialValues={{
                user: prepareUserBeforeSubmit(user),
                freelance: {
                  ...prepareFreelanceBeforeSubmit(freelance),
                  date_cdi_start: freelance.date_cdi_start || format(startOfDay(new Date()), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                }
              }}
            />
            <div className="col-md-12 mt-3 d-flex">
              <SubmitButton className="mx-auto btn btn-primary">Sauvegarder</SubmitButton>
            </div>
          </FreelancePage>

          <FreelancePage>
            <h5>Activité & historique</h5>

            <div className="mb-3">
              Commentaires internes Twineeds, visibles par tout utilisateur ayant un profil de type administrateur + DO.
            </div>

            <NavTabs navItems={[
              {
                onClick: () => this.setCurrentTab(TABS.INTERVIEW_COMMENTARY),
                isActive: this.state.currentTab === TABS.INTERVIEW_COMMENTARY,
                icon: <Users size={14} />,
                text: `Commentaires d'entretien`,
              },
              {
                onClick: () => this.setCurrentTab(TABS.COMMENTARY),
                isActive: this.state.currentTab === TABS.COMMENTARY,
                icon: <MessageCircle size={14} />,
                text: `Commentaires`,
                number: notes.length
              },
              {
                onClick: () => this.setCurrentTab(TABS.HISTORY),
                isActive: this.state.currentTab === TABS.HISTORY,
                icon: <Clock size={14} />,
                text: `Historique`,
                number: historyData.length,
              },
            ]}/>

            <TabContent activeTab={this.state.currentTab} className={`mt-4`}>
              <TabPane tabId={TABS.INTERVIEW_COMMENTARY}>
                {!this.hasInterviewInitialData ?
                  <DivCenterAlign className={'mt-4'}>
                    <div className="my-5 text-center font-italic">Aucun commentaire d'entretien</div>
                  </DivCenterAlign>
                  : <InterviewNote conf={conf} user={user} freelance={freelance} />
                }

                {(!this.hasInterviewInitialData || (this.hasInterviewInitialData && !this.props.freelance.interview_process_finished)) && (
                  <DivCenterAlign className={'mt-4'}>
                    <PrimaryButton onClick={this.editInterviewForm}>
                      {this.hasInterviewInitialData ? `Editer le` : `Créer un`}  formulaire d'entretien
                    </PrimaryButton>
                  </DivCenterAlign>
                )}
              </TabPane>

              <TabPane tabId={TABS.COMMENTARY}>
                <Notes
                  onDelete={this.onDelete}
                  onEdit={this.onEdit}
                  notes={this.state.notes}
                />

                <DivCenterAlign className={'mt-4'}>
                  <PrimaryButton onClick={this.addComment}>Ajouter un commentaire</PrimaryButton>
                </DivCenterAlign>
              </TabPane>

              <TabPane tabId={TABS.HISTORY}>
                {this.state.historyLoading
                  ? <ModerationLoading />
                  : <ModerationLoaded history={this.state.historyData} />
                }
              </TabPane>
            </TabContent>
          </FreelancePage>
        </div>

        <div className="profile-snapshot fl-pages p-4">
          <h5 className="mb-3 text-nowrap">
            Résumé du profil
          </h5>

          <ul className="profile-snapshot-list mb-4">
            <li>
              <span>Univers</span>
              <strong>{ universes[user?.universes?.[0] || 0] } </strong>
            </li>

            <li>
              <span>Statut</span>
              <strong>{ freelance?.cdi ? 'En CDI' : user?.isProgessiActive ? 'En mission' : '-'} </strong>
            </li>

            <li>
              <span>Agent</span>
              <strong>{ freelance?.agent?.fullname || '-' }</strong>
            </li>

            <li>
              <span>Disponible le</span>
              <strong>{ formatDate(freelance?.date_available) }</strong>
            </li>

            <li>
              <span>Prochaine relance</span>
              <strong>{ formatDate(freelance?.date_next_action) }</strong>
            </li>

            <li>
              <span>Début CDI</span>
              <strong>{ freelance.cdi ? formatDate(freelance?.date_cdi_start) : '-' }</strong>
            </li>

            <li>
              <span>User ID</span>
              <strong>#{user?.id ?? ''}</strong>
            </li>

            <li>
              <span>Freelance ID</span>
              <strong>#{freelance?.id ?? ''}</strong>
            </li>
          </ul>

          <h5 className="mb-3 text-nowrap">
            Informations
          </h5>

          <ul className="profile-snapshot-list mb-4">
            <li>
              <span>Compétences</span>
              <strong>{ freelance?.master_skills?.length || '-' } </strong>
            </li>

            <li>
              <span>Secteurs</span>
              <strong>{ freelance?.secteurs?.length || '-' }</strong>
            </li>

            <li>
              <span>Missions</span>
              <strong>{ freelance?.experiences?.length || '-' }</strong>
            </li>

            <li>
              <span>Diplômes</span>
              <strong>{ freelance?.diplomes?.length || '-' }</strong>
            </li>

            <li>
              <span>Certifications</span>
              <strong>{ freelance?.certifications?.length || '-' }</strong>
            </li>

            <li>
              <span>Outils et logiciels</span>
              <strong>{ freelance?.it_skills?.length || '-' }</strong>
            </li>

            <li>
              <span>Langues</span>
              <strong>{ freelance?.languages?.length || '-' }</strong>
            </li>
          </ul>

          { user?.linkedin_url ? (
            <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm w-100 btn-secondary">
              <Linkedin className="mr-1" />
              LinkedIn
            </a>
          ) : (
            <Link to={linkedinUrl} className="btn btn-sm w-100 btn-outline-secondary">
              <Linkedin className="mr-1" />
              Aucun LinkedIn
            </Link>
          )}

          <button type="button" className="btn btn-sm w-100 btn-secondary mt-2" onClick={() => this.onCvNormalizedDownloaded(false, false)}>
            <Download className="mr-1" />
            Télécharger le DC
          </button>

          <Link to={cvUrl} className={`btn btn-sm w-100 mt-2 ${freelance?.cv ? 'btn-secondary mb-2' : 'btn-outline-secondary'}`}>
            <File className="mr-1" />
            { freelance?.cv ? 'CV' : 'Aucun CV' }
          </Link>
          {lastCvEntry && <span className="form-caption text-center">Uploadé le {formatDate(lastCvEntry.created_at)}</span>}
        </div>
      </div>
    )
  }
}

export default connectModal({CommentsModal}, MustBeAdmin(Monitor))
